import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useAddMainPageGroup = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncAddMainPageGroup, isPending } = useMutation('addMainPageGroup', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['main-page-group'] });
      toast.success(res.message);
      await revalidate(['all']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncAddMainPageGroup, isPending };
};

export default useAddMainPageGroup;
